



















import {
  QuestionObjective,
  QuestionSubjective,
} from '@/resource/question/question.model';
import getLevel from '@/utils/common/get-level';
import truncateString from '@/utils/common/truncate';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class QuestionDetail extends Vue {
  @Prop({ required: true })
  question: QuestionObjective | QuestionSubjective;

  @Prop({ default: false })
  isHideSubjectName: boolean;

  get chapterDesktop() {
    return this.question.chapter.subject.isNoLevel
      ? truncateString(this.question.chapter.name, 20)
      : `Chapter ${this.question.chapter.prefix}`;
  }

  get chapterMobile() {
    return this.question.chapter.subject.isNoLevel
      ? truncateString(this.question.chapter.name, 10)
      : `Chapter ${this.question.chapter.prefix}`;
  }

  get chapterName() {
    return this.question.chapter.name;
  }

  get form() {
    return getLevel(this.question.chapter.form);
  }

  get subject() {
    return this.question.chapter.subject.name;
  }
}
